import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePeriodoComissionamentos } from '../hooks/usePeriodoComissionamentos';
// Esqueleto de página compartilhado (`recepcao-conte-do`, `recepcao-header-row`,
// `recepcao-title`). O import é explícito de propósito: depender de CSS carregado por
// outra tela é acoplamento invisível — foi o que originou o BUG-V74 na at-67.
import '../../recepcao/pages/Recepcao.css';
import './pagamentos.css';
import DadosAtualizadosEm from '../components/DadosAtualizadosEm';
import AbasDoQualificado from '../components/AbasDoQualificado';

interface LocationState {
  item?: {
    id: string;
    codigo: string;
    nome: string;
    contratos: number;
  };
  origem?: 'cooperativa' | 'voluntario';
  qualificado_tipo?: string;
  qualificado_uuid?: string;
}

const PagamentosPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | null;

  const item = state?.item;
  const origem = state?.origem;
  const [periodo] = usePeriodoComissionamentos();
  const qualificadoTipo = state?.qualificado_tipo ?? (origem === 'cooperativa' ? 'COOPERATIVA' : 'VOLUNTARIO');

  const formatPeriodo = (p: string) => {
    const [mm, yyyy] = p.split('-');
    return `${mm}/${yyyy}`;
  };

  const handleVoltar = () => {
    navigate('/comissionamentos/listas', { state: { defaultTab: origem } });
  };

  if (!item) {
    return (
      <div
        className="Frame1000004012"
        style={{
          height: 'fit-content',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          backgroundColor: 'transparent',
        }}
      >
        {/* Estado de "nenhum item selecionado": mesmo esqueleto, sem cabeçalho — não há
            navegação a oferecer, e o conteúdo exibido é o mesmo de antes. */}
        <div className="ConteDo recepcao-conte-do pagamentos-conte-do">
          <div className="error-message">
            <h2>Nenhum item selecionado</h2>
            <p>Selecione uma cooperativa ou voluntário na lista para ver os pagamentos.</p>
            <button onClick={() => navigate('/comissionamentos/listas')} className="btn-voltar">
              Voltar para a lista
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="Frame1000004012"
      style={{
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        backgroundColor: 'transparent',
      }}
    >
      {/*
        Esqueleto COMPARTILHADO de página. `recepcao-conte-do` e `recepcao-header-row`
        substituem o contêiner `.pagamentos-container`, que tinha margens próprias e não
        acompanhava as demais telas. A classe local abaixo guarda só o respiro inferior.
      */}
      <div className="ConteDo recepcao-conte-do pagamentos-conte-do">
        {/* Header. `pagamentos-header` ficou só com a faixa laranja de separação — o resto
            do cabeçalho vem do esqueleto compartilhado. */}
        <div className="recepcao-header-row pagamentos-header">
          <button onClick={handleVoltar} className="btn-back">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Voltar
          </button>
          <div className="recepcao-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            Pagamentos
          </div>
        </div>
        <DadosAtualizadosEm />

        <AbasDoQualificado
          ativa="pagamentos"
          estado={{ item, origem, qualificado_tipo: qualificadoTipo, qualificado_uuid: item?.id }}
        />

        {/* Resumo */}
        <div className="item-resumo">
          <div className="resumo-card">
            <h2>Resumo do Período</h2>
            <div className="resumo-dados">
              <div className="dado-item">
                <span className="label">Tipo:</span>
                <span className="valor"><span className="badge">{qualificadoTipo === 'COOPERATIVA' ? 'Cooperativa' : 'Voluntário'}</span></span>
              </div>
              <div className="dado-item">
                <span className="label">Código:</span>
                <span className="valor">{item.codigo}</span>
              </div>
              <div className="dado-item">
                <span className="label">Nome:</span>
                <span className="valor">{item.nome}</span>
              </div>
              <div className="dado-item">
                <span className="label">Período:</span>
                <span className="valor">{formatPeriodo(periodo)}</span>
              </div>
              <div className="dado-item">
                <span className="label">Contratos:</span>
                <span className="valor">{item.contratos > 0 ? item.contratos : '—'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Card "Em desenvolvimento" */}
        <div className="pagamentos-table-container">
          <div className="pending-message">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9e9e9e" strokeWidth="1.5">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <h3>Funcionalidade em desenvolvimento</h3>
            <p>A visualização detalhada de pagamentos será implementada em breve.</p>
            <div className="pending-features">
              <span>Histórico de pagamentos</span>
              <span>Status de processamento</span>
              <span>Comprovantes</span>
              <span>Relatórios</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagamentosPage;
